export default "__VITE_ASSET__CLCjIN$i__"